import {ChangeDetectionStrategy, Component, Input} from '@angular/core'
import {faInfoCircle} from '@fortawesome/pro-solid-svg-icons/faInfoCircle'

@Component({
  selector: 'cft-minimum-price-card',
  templateUrl: './minimum-price-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [':host { display: block }'],
})
export class MinimumPriceCardComponent {
  @Input() offering!: {label: string; icon?: {name: string; collection: string}}
  @Input() minimumPrice!: number
  @Input() priceLabel!: string
  @Input() infoLabel?: string

  @Input() transparent = false

  readonly infoIcon = faInfoCircle
}
